import { ValueOf } from '@ahha/utils/@types/typeUtils'

/**
 * 라이센스 티어 정의
 * - PRO: 40001 (하위 티어: 이미지/시계열/태뷸러 조합)
 * - TEAMS: 40002
 * - OPS: 40003
 */
export const LicenseTier = {
  NO_LICENSE: 'NO_LICENSE',
  PRO_IMG: 'PRO_IMG', // 이미지만
  PRO_TS: 'PRO_TS', // 시계열만
  PRO_TAB: 'PRO_TAB', // 태뷸러만
  PRO_IMG_TS: 'PRO_IMG_TS', // 이미지 + 시계열
  PRO_IMG_TAB: 'PRO_IMG_TAB', // 이미지 + 태뷸러
  PRO_TS_TAB: 'PRO_TS_TAB', // 시계열 + 태뷸러
  PRO_IMG_TS_TAB: 'PRO_IMG_TS_TAB', // 이미지 + 시계열 + 태뷸러
  TEAMS: 'TEAMS',
  OPS: 'OPS',
} as const

export type LicenseTierType = ValueOf<typeof LicenseTier>

// 소켓으로부터 받는 라이센스 체크 결과 페이로드
export interface CheckLicenseResultPayload {
  allFailed: boolean // true면 라이센스 키 없음
  passedFeatures: number[] // 통과한 기능 코드 (40001, 40002, 40003)
  failedFeatures: number[] // 실패한 기능 코드
  conditionalResult?: {
    // PRO(40001)일 때만 존재
    allFailed: boolean
    passedConditionalFeatures: number[] // 41001: 이미지, 41002: 시계열, 41003: 태뷸러
    failedConditionalFeatures: number[]
  }
}

// localStorage에 저장되는 라이센스 정보
export interface LicenseInfo {
  tier: LicenseTierType
  passedFeatures: number[]
  conditionalFeatures?: number[]
}
